import script from "./ExportSpecificFile.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportSpecificFile.vue?vue&type=script&lang=ts&setup=true"

import "./ExportSpecificFile.vue?vue&type=style&index=0&id=26422ed7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26422ed7"]])

export default __exports__